export * from './support-language-class.module';
